export function convertQueryInputToSingleElement(
  input: string | string[] | undefined
) {
  return Array.isArray(input) ? input[0] : input;
}
